// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

export default function Services() {
  const handleWhatsAppClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  const services = [
    {
      title: 'Pintura Residencial',
      description: 'Pintura completa de residências com acabamento impecável. Trabalhamos com as melhores marcas de tintas do mercado, garantindo durabilidade e beleza para sua casa.',
      image: 'https://public.readdy.ai/ai/img_res/42a6edc7536caf97a7cfaee75e7982d5.jpg',
      icon: 'ri-home-4-line',
    },
    {
      title: 'Pintura Comercial',
      description: 'Pintura profissional para estabelecimentos comerciais, escritórios e lojas. Trabalhamos em horários flexíveis para não atrapalhar seu negócio.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20commercial%20painting%20service%20showing%20painters%20working%20in%20modern%20office%20space%20or%20retail%20store%20interior%20with%20clean%20white%20walls%20professional%20equipment%20and%20business%20environment%20during%20renovation%20with%20minimal%20background%20simple%20clean%20setting&width=600&height=400&seq=commercialpainting2024&orientation=landscape',
      icon: 'ri-building-line',
    },
    {
      title: 'Pintura de Prédios',
      description: 'Especialistas em pintura de fachadas e áreas comuns de condomínios. Equipe treinada com todos os equipamentos de segurança necessários.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20building%20exterior%20painting%20service%20with%20workers%20on%20scaffolding%20painting%20apartment%20building%20facade%20in%20bright%20daylight%20with%20clean%20white%20and%20beige%20colors%20modern%20architecture&width=600&height=400&seq=service3&orientation=landscape',
      icon: 'ri-community-line',
    },
    {
      title: 'Texturas Decorativas',
      description: 'Aplicação de texturas especiais como grafiato, granfino, pedras cristais e muito mais. Transforme suas paredes com acabamentos diferenciados.',
      image: 'https://readdy.ai/api/search-image?query=Decorative%20wall%20texture%20application%20service%20showing%20textured%20wall%20finish%20with%20grafiato%20or%20decorative%20plaster%20in%20elegant%20interior%20setting%20with%20warm%20neutral%20tones&width=600&height=400&seq=service4&orientation=landscape',
      icon: 'ri-brush-line',
    },
    {
      title: 'Reparos em Gesso',
      description: 'Reparos e acabamentos em gesso para paredes e tetos. Corrigimos imperfeições, trincas e realizamos acabamentos perfeitos antes da pintura.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20drywall%20and%20plaster%20repair%20service%20worker%20fixing%20wall%20cracks%20and%20imperfections%20with%20tools%20in%20clean%20interior%20space%20with%20white%20walls&width=600&height=400&seq=service5&orientation=landscape',
      icon: 'ri-tools-line',
    },
    {
      title: 'Reparos Gerais',
      description: 'Serviços de rejunte, troca de pisos quebrados e diversos reparos gerais. Soluções completas para deixar seu imóvel impecável.',
      image: 'https://readdy.ai/api/search-image?query=General%20home%20repair%20and%20maintenance%20service%20showing%20floor%20tile%20replacement%20and%20grout%20work%20in%20modern%20clean%20interior%20with%20professional%20tools&width=600&height=400&seq=service6&orientation=landscape',
      icon: 'ri-hammer-line',
    },
  ];

  return (
    <section id="servicos" className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Serviços de Pintura em São José dos Campos
          </h2>
          <p className="text-xl text-gray-600 mb-6">
            Soluções completas em pintura e reparos com mais de 20 anos de experiência
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-yellow-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all transform hover:scale-105 duration-300"
            >
              <div className="relative">
                <img
                  src={service.image}
                  alt={service.title}
                  title={service.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-white text-xl`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  <strong>{service.title}</strong>
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                <a
                  href="https://wa.me/5512981564801"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleWhatsAppClick}
                  className="bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white px-6 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2 whitespace-nowrap cursor-pointer w-fit"
                >
                  <i className="ri-whatsapp-line"></i>
                  <span>Orçamento Grátis</span>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center bg-gradient-to-r from-orange-500 to-yellow-500 rounded-2xl p-12 text-white">
          <h3 className="text-3xl font-bold mb-4">🎨 Precisa de Pintura em São José dos Campos?</h3>
          <p className="text-xl mb-6 max-w-3xl mx-auto">
            <strong>Mais de 20 anos de experiência</strong> transformando ambientes! Equipe especializada com
            equipamentos profissionais. Orçamento gratuito pelo WhatsApp agora!
          </p>
          <a
            href="https://wa.me/5512981564801"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleWhatsAppClick}
            className="bg-white text-orange-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer shadow-xl"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>Fale Conosco Agora</span>
          </a>
        </div>
      </div>
    </section>
  );
}
